import React from "react";

import classnames from "classnames";
import { useFormikContext } from "formik";

import { Label, Switch, Tooltip } from "clearsense-ui/components";
import { Input, Textarea, DatePicker } from "clearsense-ui/components/formik";

const Fields = ({ subTab, activeTab, isViewMode, currentTemplate }) => {
  const { values, initialValues, setFieldValue } = useFormikContext();
  let isValueDisabled;

  const getValue = (fieldName, values) => {
    isValueDisabled = !values?.[activeTab]?.filter(item => !item?.hidden)
      ?.length;
    return values[activeTab]?.[subTab]?.[fieldName];
  };

  const getField = field => {
    const { type, name } = field;
    const fieldName = `${activeTab}.${subTab}.${name}`;

    switch (type) {
      case "text":
      case "string":
      case "number":
        return (
          <Input
            name={fieldName}
            value={getValue(name, values) || ""}
            disabled={isValueDisabled || isViewMode}
          />
        );
      case "textarea":
        return (
          <Textarea
            name={fieldName}
            value={getValue(name, values) || ""}
            disabled={isValueDisabled || isViewMode}
          />
        );
      case "date":
        return (
          <DatePicker
            name={fieldName}
            size="large"
            dateFormat="YYYY-MM-DD"
            value={getValue(name, values) || ""}
            disabled={isValueDisabled || isViewMode}
          />
        );
      case "switch":
      case "boolean":
        return (
          <Switch
            name={fieldName}
            onChange={e =>
              setFieldValue(fieldName, e.target.checked ? "Y" : "N")
            }
            checked={getValue(name, values) === "Y"}
            disabled={isValueDisabled || isViewMode}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {currentTemplate?.template?.hierarchies
        .find(item => item?.name === activeTab)
        ?.fields?.map(field => (
          <div
            key={field.name}
            className="flex space-x-2 items-center justify-start"
          >
            <Label
              className={classnames("w-80 leading-5", {
                "text-yellow-600":
                  getValue(field.name, values) !==
                  getValue(field.name, initialValues),
              })}
            >
              {field.name}
            </Label>
            <div className="flex w-full">
              <Tooltip
                disabled={
                  !!values?.[activeTab]?.length || activeTab === "primary"
                }
                content="No record found"
                position="top"
              >
                <div
                  className={classnames({ "w-full": field.type !== "boolean" })}
                >
                  {getField(field)}
                </div>
              </Tooltip>
            </div>
          </div>
        ))}
    </>
  );
};

export default Fields;
